<template>
    <div>
        <page-header :heading="pageHeader.title" />

        <search-form key="claimPaymentSearch"
                     :inputs="searchInputs"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />
        <div class="row border-bottom">
            <div class="col-6">
                <page-size v-model="pageSize"
                           @input="handlePageSizeChange" />
            </div>
            <div class="col-6">
                    <div class="mb-2 float-right">
            <div class="row">
                <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                    <div class="btn-toolbar" role="toolbar">
                        <div class="btn-group btn-group-justified" role="group">
                            <div class="btn-group" role="group">
                                <button id="new" class="btn btn-primary" data-original-title="New" disabled><i class="fas fas fa-plus" aria-hidden="true"></i></button>
                                  <b-modal :id="'claim-payment-viewedit-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer>
                                      <div v-if="viewEditItem">
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Claim Reference</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.claimReference}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Device</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.device}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>IMEI Number</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.imeino}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Payee Type</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.payee}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Supplier</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.supplier}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Reference</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.reference}}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-2">
                                              <div class="col pl-4 p-2">
                                                  <span>Description</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.description}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Payment Type</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.paymentType}}</span>
                                              </div>
                                          </div>

                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Transaction Type</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.transaction}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Status</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.status}}</span>
                                              </div>
                                          </div>
                                          <hr />
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Authorised</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.authorised}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Authorised By</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.authorisedBy}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Rejected</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.rejected}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Rejected By</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.rejectedBy}}</span>
                                              </div>
                                          </div>
                                          <hr />
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Currency</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>GBP</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col pl-4 p-2">
                                                  <span>Payment Date</span>
                                              </div>
                                              <div class="col-7 border-left pl-4 p-2">
                                                  <span>{{viewEditItem.paymentDate}}</span>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-5 pl-4 p-2">
                                                  <span>Net</span>
                                              </div>
                                              <div class="col-4 border-left pl-4 p-2">
                                                  <input type="text" class="form-control" id="claimPaymentNet" :disabled="!isEditable">

                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-5 pl-4 p-2">
                                                  <span>Tax</span>
                                              </div>
                                              <div class="col-4 border-left pl-4 p-2">
                                                  <input type="text" class="form-control" id="claimPaymentTax" :disabled="!isEditable">

                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-5 pl-4 p-2">
                                                  <span>Gross</span>
                                              </div>
                                              <div class="col-4 border-left pl-4 p-2">
                                                  <input type="text" class="form-control" id="claimPaymentGross" :value="viewEditItem.amount" :disabled="!isEditable">

                                              </div>
                                          </div>
                                          <hr />
                                          <div class="float-right">
                                              <button type="button" class="btn btn-secondary">Close</button>
                                              <button type="button" class="btn btn-primary ml-2">OK</button>
                                          </div>
                                      </div>
</b-modal>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
                            </div>
        </div>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                <b-form-checkbox v-model="selectAll"
                                                 @input="handleSelectAll()">
                                </b-form-checkbox>
                            </th>
                            <th>ClaimReference</th>
                            <th>Device</th>
                            <th>IMEI</th>
                            <th>Payee</th>
                            <th>Supplier</th>
                            <th>Reference</th>
                            <th>Description</th>
                            <th>Payment Type</th>
                            <th>Transaction Type</th>
                            <th>Gross</th>
                            <th>Status</th>
                            <th>Authorised</th>
                            <th>Authorised By (Claims)</th>
                            <th>Rejected</th>
                            <th>Rejected By (Claims)</th>
                            <th>Payment Status</th>
                            <th>Payment Date</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="19">
                                <div class="d-flex justify-content-center mb-3 mt-3">
                                    <b-spinner label="Loading..."></b-spinner>
                                </div>
                            </td>
                        </tr>
                        <tr v-else v-for="(itm,idx) in bucketItems"
                            :key="'claimpayment_' + idx"
                            :class=" selectedItems.includes(idx) ? 'table-primary' : ''"
                            :style="'cursor: pointer'"
                            @click="handleItemClick(idx)">
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox"
                                           class="custom-control-input"
                                           :key="'check_' + idx"
                                           :ref="'check_' + idx"
                                           :value="idx"
                                           :name="'check_' + idx"
                                           v-model="selectedItems">
                                    <label class="custom-control-label"
                                           :for="'check_' + idx"></label>
                                </div>
                            </td>
                            <td>{{itm.claimReference}}</td>
                            <td>{{itm.device | truncate(15)}}</td>
                            <td>{{itm.imeino}}</td>
                            <td>{{itm.payee}}</td>
                            <td>{{itm.supplier}}</td>
                            <td>{{itm.reference}}</td>
                            <td>{{itm.description}}</td>
                            <td>{{itm.paymentType}}</td>
                            <td>{{itm.transaction}}</td>
                            <td>&pound;{{itm.amount | currency}}</td>
                            <td>{{itm.status}}</td>
                            <td>{{itm.authorised | datetime}}</td>
                            <td>{{itm.authorisedBy}}</td>
                            <td>{{itm.rejected}}</td>
                            <td>{{itm.rejectedBy}}</td>
                            <td><span v-if="itm.paymentStatus" :class="getStatusBadgeClass(itm.paymentStatus)">{{itm.paymentStatus}}</span></td>
                            <td>{{itm.paymentDate | datetime}}</td>
                            <td>
                                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'" @show="handleItemClick(idx)">
                                    <template v-slot:button-content>
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                        <span class="sr-only">Actions menu</span>
                                    </template>
                                    <b-dropdown-item href="javascript:void(0)" @click="handleViewEditClick(0,idx,itm)" :disabled="false">
                                        <i v-if="false" :class="iconClass"></i> View
                                    </b-dropdown-item>
                                    <b-dropdown-item href="javascript:void(0)" @click="handleViewEditClick(1,idx,itm)" :disabled="!canUserEdit">
                                        <i v-if="false" :class="iconClass"></i> Edit
                                    </b-dropdown-item>
                                    <b-dropdown-item href="javascript:void(0)" @click="handleDeleteClick(idx,itm)" :disabled="false">
                                        <i v-if="false" :class="iconClass"></i> Delete
                                    </b-dropdown-item>
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-dropdown-item href="javascript:void(0)" @click="handleAuthoriseClick(idx,itm)" :disabled="false">
                                        <i v-if="false" :class="iconClass"></i> Authorise
                                    </b-dropdown-item>
                                    <b-dropdown-item href="javascript:void(0)" @click="handleAuthoriseClick(idx,itm)" :disabled="false">
                                        <i v-if="false" :class="iconClass"></i> Reject
                                    </b-dropdown-item>
                                </b-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-pagination v-if="!loading" v-model="pageNumber"
                              :total-rows="totalPages"
                              :per-page="pageSize"
                              aria-controls="my-table"></b-pagination>
            </div>
</template>
<script>
    import { mapActions, mapGetters } from "vuex";

    import PageSize from '@/components/PageSize.vue'
    import SearchForm from '@/components/SearchForm.vue'
    import OrderBy from '@/components/OrderBy.vue'
    import PageHeader from '@/components/PageHeader.vue'

    export default {
        components: {
            'page-header': PageHeader,
            'page-size': PageSize,
            'search-form':  SearchForm,
            'order-by': OrderBy
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'All Claim Payments'
                },
                pageNumber: 1,
                pageSize: 10,
                loading: false,
                searchInputs: [
                    {
                        id: 'claimReference',
                        label: 'Claim Reference',
                        type: 'text',
                        placeholder: 'Claim Reference'
                    },
                    {
                        id: 'relatedReference',
                        label: 'Related Reference',
                        type: 'text',
                        placeholder: 'Related Reference'
                    },
                    {
                        id: 'imeiNumber',
                        label: 'IMEI Number',
                        type: 'text',
                        placeholder: 'IMEI Number'
                    },
                    {
                        id: 'supplier',
                        label: 'Supplier',
                        type: 'select',
                        options: [
                            {
                                id: 1000,
                                label: 'Apple Genius Bar'
                            },
                            {
                                id: 1002,
                                label: 'Samsung Support Centre'
                            },
                            {
                                id: 1016,
                                label: 'TMT First'
                            },
                            {
                                id: 1017,
                                label: 'SPG'
                            },
                            {
                                id: 1018,
                                label: 'AMSYS'
                            }]
                    },
                    {
                        id: 'paymentType',
                        label: 'Payment Type',
                        type: 'select',
                        options: [
                            {
                                id: 1,
                                label: 'Cash Settlement'
                            },
                            {
                                id: 2,
                                label: 'Repair'
                            },
                            {
                                id: 3,
                                label: 'Replacement'
                            },
                            {
                                id: 4,
                                label: 'Excess'
                            },
                            {
                                id: 5,
                                label: 'Contribution - Claimant'
                            },
                            {
                                id: 6,
                                label: 'Contribution - Other Insurer'
                            }]
                    },
                    {
                        id: 'payeeType',
                        label: 'Payee Type',
                        type: 'select',
                        options: [
                            {
                                id: 1,
                                label: 'Company'
                            },
                            {
                                id: 2,
                                label: 'Claimant'
                            },
                            {
                                id: 3,
                                label: 'Supplier'
                            }]
                    },
                    {
                        id: 'transactionType',
                        label: 'Transaction Type',
                        type: 'select',
                        options: [
                            {
                                id: 1,
                                label: 'DEBIT'
                            },
                            {
                                id: 2,
                                label: 'CREDIT'
                            }]
                    },
                    {
                        id: 'paymentStatus',
                        label: 'Payment Status',
                        type: 'select',
                        options: [
                            {
                                id: 1000,
                                label: 'AUTHORISED'
                            },
                            {
                                id: 1002,
                                label: 'SCHEDULED'
                            },
                            {
                                id: 1003,
                                label: 'PAID'
                            },
                            {
                                id: 1004,
                                label: 'REJECTED'
                            }]
                    }
                ],
                selectAll: false,
                selectedItem: null,
                selectedItems: [],
                viewEditMode: 0,
                viewEditItem: null
            }
        },
        watch: {
            pageNumber(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.search()
                }
            },
            pageSize(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.search()
                }
            }
        },
        computed: {
            ...mapGetters({
                bucketItems: "claimPayments/getBucketItems",
                bucketItemsPagination: "claimPayments/getBucketItemsPagination",
                bucketItemsSearchCriteria: "claimPayments/getBucketItemsSearchCriteria",
                bucketItemsSearchInputs: "claimPayments/getBucketItemsSearchInputs"
            }),
            totalPages() {
                if (this.bucketItemsPagination) {
                    let { totalPages } = this.bucketItemsPagination
                    return totalPages
                } else {
                    return 0
                }
            },
            selectedItemByIndex() {
                if (this.selectedItem && this.selectedItem > -1) {
                    return this.bucketItems[this.selectedItem]
                } else {
                    return null
                }
                
            },
            canUserEdit() {
                return false
            },
            isEditable() {
                if (this.viewEditMode == 1) {
                    return true
                }
                return false
            }
        },
        methods: {
            ...mapActions({
                loadBucketItems: "claimPayments/loadBucketItems",
                setBucketItemsSearchCriteria: "claimPayments/setBucketItemsSearchCriteria"
            }),
            handleSearchClick(ev) {
                this.setBucketItemsSearchCriteria(ev)
                this.search()
            },
            handleClearClick(ev) {
                console.log('-clear ev:', ev)
                this.setBucketItemsSearchCriteria(ev)
            },
            buildSearchCriteria() {
                let { pageNumber, pageSize, bucketItemsSearchCriteria } = this
                
            },
            handleItemClick(item) {
                this.selectedItem = item

                if (!this.selectedItems.includes(item)) {
                    this.selectedItems.push(item)
                } else {
                    let index = this.selectedItems.indexOf(item)
                    this.selectedItems.splice(index, 1)
                }
            },
            handleSelectAll() {
                console.log('-selectAll: ', this.selectAll)
                if (this.selectAll) {
                    this.selectedItems = []
                    let total = this.bucketItems.length
                    for (let i = 0; i < total; i++) {
                        this.selectedItems.push(i)
                    }
                } else {
                    this.selectedItems = []
                }
            },
            handlePageSizeChange(ev) {
                this.PageSize = ev
            },
            search() {
                let { pageNumber, pageSize } = this
                let { claimReference, imeiNumber, payeeType, paymentType, relatedReference, supplier, transactionType, paymentStatus } = this.bucketItemsSearchCriteria

                this.loading = true
                this.loadBucketItems({
                    pageNumber, pageSize, supplier: supplier.label, claimReference, imeiNo: imeiNumber,
                    payeeType: payeeType.label, paymentType: paymentType.label, transactionType: transactionType.label, paymentStatus: paymentStatus.label
                })
                    .finally(() => this.loading = false)
            },
            handleViewEditClick(mode, idx, itm) {
                console.log('-mode: ', mode)
                console.log('-idx: ', idx)
                console.log('-itm: ', itm)
                this.viewEditMode = mode
                this.viewEditItem = itm
                this.$bvModal.show('claim-payment-viewedit-modal-' + this.$vnode.key)
            },
            getStatusBadgeClass(status) {
                switch (status) {
                    case 'PAID':
                        return 'badge badge-success'
                        break;
                    case 'AUTHORISED':
                        return 'badge badge-warning'
                        break;
                    case 'SCHEDULED':
                        return 'badge badge-warning'
                        break;
                    case 'REJECTED':
                        return 'badge badge-danger'
                        break;
                    default:

                }
            }
        },
        mounted() {
            let { pageNumber, pageSize } = this
            this.loading = true
            this.loadBucketItems({ pageNumber, pageSize })
                //.then(response => console.log('-bi: ', this.bucketItems))
                .finally(()=>this.loading = false)
            
        }
    }
</script>